import { render, staticRenderFns } from "./textModal.vue?vue&type=template&id=694d8538&"
import script from "./textModal.vue?vue&type=script&lang=js&"
export * from "./textModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports